import { useContext, useEffect } from 'react';

import { Store } from '@src/store';
import { setDraftLS } from '@src/utils';

export const useDraft = () => {
  const {
    state: {
      statePetsTelevetPlus: {
        selectedIProduct,
        risks,
        insuranceSum,
        getPrices,
        getPricesFull,
        selectedDuration,
        selectedDate,
        promoCode,
        promoCodeApplyed,
        risksPage,
        pets,
        selectedPetData,
        sublimits,
        selectedPetKindName,
        currentSum,
        insurancePrograms,
      },
      statePetsTelevetPlus,
      stateUser: { profile, selectedProduct, agentLogin },
      stateWizard: { currentStep },
    },
  } = useContext(Store);

  useEffect(() => {
    if (!agentLogin) {
      const data = {
        dataObject: {
          ...statePetsTelevetPlus,
          promoCode: promoCodeApplyed && promoCode,
        },
        profile,
        selectedProduct,
        currentStep: currentStep || 0,
      };

      setDraftLS(data);
    }
  }, [
    selectedIProduct,
    risks,
    insuranceSum,
    getPrices,
    getPricesFull,
    selectedDuration,
    selectedDate,
    promoCode,
    promoCodeApplyed,
    risksPage,
    pets,
    selectedPetData,
    sublimits,
    selectedPetKindName,
    currentSum,
    agentLogin,
    insurancePrograms,
  ]);

  return;
};
